import VueMoment from 'vue-moment';
import Vue from 'vue';
Vue.use(VueMoment);
